import React, { Component } from "react";
import ChoicePopup from "../2/Controls/ChoicePopup";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import Button from "../2/Controls/Button";
import * as actionTypes from "../../actionTypes";
import { exportFile } from "../../actions/DataExporter";
import Spinner from "../Common/Spinner";

const customField1 = "Custom Field 1";
const customField2 = "Custom Field 2";
const customField3 = "Custom Field 3";
const customField4 = "Custom Field 4";
const customField5 = "Custom Field 5";
const customField6 = "Custom Field 6";

class InventoryList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      selectAll: false,
      stores: [],
      cashRegisters: [],
      showNewModal: false,
      showConvertPopup: false,
      searchParam: "",
      inventoryTransactionTypes: [],
      showParkedModal:false,
      inventoryDrafts:[],
      filter: {
        storeId: "",
        transactionTypeId: "",
        fromDate: "",
        toDate: "",
        transactionNo: "",
        vendorFirstName: "",
        vendorPhoneNo: "",
        vendorEmailId: "",
        vendorCode: "",
        refNo: "",
      },
      showFilter: false,
      showOption: false,
      selectedRow: null,
      isFilterActive: false,
      showSelectionOption: false,

      listPageSettings: {
        Title: "Inventory List",
        Search: {
          showSearch: true,
          placeholder: "Search by transaction no, vendor name, email id or phone no",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },
        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "secondary",
            Text: "Convert",
            Icon: "",
            Action: "convert"
          },
            {
            ButtonType: "Button",
            Type: "secondary",
            Text: "Parked",
            Icon: "",
            Action: "Parked"
          },
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }
        ],
        Columns: [
          { Name: "", Type: "checkbox" },
          {
            Name: "#",
            Type: "multiple",
            Columns: [
              { Column: "TransactionNo" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" },
              {
                Column: "ParentTransactions",
                Type: "list",
                Columns: [
                  {
                    Column: "ParentTransactionNo",
                    Type: "badge",
                    CSS: "green",
                  },
                ],
              },
              {
                Column: "ChildTransactions",
                Type: "list",
                Columns: [
                  { Column: "ChildTransactionNo", Type: "badge", CSS: "blue" },
                ],
              },
              { Column: "ParentTransactionNo", Type: "badge", CSS: "green" },
              { Column: "ChildTransactionNo", Type: "badge", CSS: "blue" },
            ],
          },
          {
            Name: "Transaction Type",
            Type: "field",
            Columns: [
              { Column: "TransactionType.TransactionType", Type: "text" },
            ],
          },
          {
            Name: "Date",
            Type: "field",
            Columns: [{ Column: "TransactionDate", Type: "date" }],
          },
          {
            Name: "Store",
            Type: "field",
            Columns: [{ Column: "Store.StoreName" }],
          },
          {
            Name: "Vendor/Store",
            Type: "multiple",
            Columns: [
              { Column: "Vendor.VendorFirstName", Type: "text" },
              { Column: "Vendor.VendorLastName", Type: "text" },
              { Column: "Vendor.VendorCode", Type: "text" },
              { Column: "FromStore", Type: "text" },
              { Column: "ToStore", Type: "text" },
            ],
          },
          {
            Name: "Ref No",
            Type: "field",
            Columns: [{ Column: "RefNo", Type: "text" }],
          },
          {
            Name: "Notes",
            Type: "field",
            Columns: [{ Column: "Notes", Type: "text" }],
          },
          {
            Name: "Qty",
            Type: "field",
            Columns: [{ Column: "BillQty", Type: "number" }],
          },
          {
            Name: "Total Tax",
            Type: "field",
            Columns: [{ Column: "BillTaxAmount", Type: "number" }],
          },
          {
            Name: "Discount",
            Type: "field",
            Columns: [{ Column: "BillDiscount", Type: "number" }],
          },
          {
            Name: "Additional Discount",
            Type: "field",
            Columns: [{ Column: "BillAdditionalDiscount", Type: "number" }],
          },
          {
            Name: "Additional Charges",
            Type: "field",
            Columns: [{ Column: "BillAdditionalCharges", Type: "number" }],
          },
          {
            Name: "Round Off",
            Type: "field",
            Columns: [{ Column: "BillRoundOff", Type: "number" }],
          },
          {
            Name: "Amount",
            Type: "field",
            Columns: [{ Column: "BillAmount", Type: "number" }],
          },
          {
            Name: "Status",
            Type: "field",
            Columns: [{ Column: "Status", Type: "text" }],
          },
          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "TransactionNo", CSS: "bold" },
              { Column: "TransactionType.TransactionType" },
              { Column: "TransactionDate", Type: "date" },
              { Column: "Store.StoreName" },
              { Column: "BillQty", Type: "text", Label: "Qty" },
              { Column: "BillAmount", Type: "text", Label: "Amount" },
              { Column: "Status", Type: "badge" },
            ],
          },
        ],
        RowButtons: [
        ]
      }
    };
  }

  checkboxSelected = (index) => {
    let list = [...this.state.list];

    if (index === -1) {
      let selectAll = !this.state.selectAll;
      list = list.map(l => ({ ...l, Selected: selectAll }));
      this.setState({ selectAll: selectAll, list: list });
    } else {
      if (index < list.length) {
        list[index] = { ...list[index], Selected: !list[index].Selected };
        this.setState({ list: list });
      }
    }

    const hasSelected = list.filter(f => f.Selected).length > 0;
    this.setState({ showSelectionOption: hasSelected });
  };

  async loadCashRegister(storeId) {
    let cashRegisters = await this.props.getCashRegisters(storeId);
    this.setState({ cashRegisters: cashRegisters });
  }

  renderNewInventoryPopup() {
    return (
      <React.Fragment>
        {this.state.inventoryTransactionTypes.map((e) => (
          <Button
            key={e.key}
            text={"New " + e.TransactionType}
            type="secondary"
            icon="add"
          onClick={() => {
                        this.props.history.push({
                          pathname: "/home/inventory/inventory/",
                          state: { transactionType: e, type: actionTypes.INVENTORY_NEW },
                        });
                      }}
          />
        ))}
      </React.Fragment>
    );
  }

  renderConvertInventory() {
    return (
      <React.Fragment>
        {this.state.inventoryTransactionTypes
          .filter(
            (e) =>
              e.Module === "inventory" &&
              !e.IsDeleted &&
              e.TransactionType.toLowerCase() !== "transfer in"
          )
          .map((e) => (
            <Button
              key={e.key}
              text={"New " + e.TransactionType}
              type="secondary"
              icon="add"
              onClick={() => {
                this.onConvertTransaction(e, false);
              }}
            />
          ))}
      </React.Fragment>
    );
  }

  showTransactionType(transactionType) {
    let showModule = false;
    if (
      this.props.user.user.Role === "Power User" ||
      this.props.user.user.Role === "Store Owner" ||
      this.props.user.user.Role === "Store Manager" ||
      this.props.user.user.Role === "Store Cashier"
    ) {
      showModule = true;
    } else {
      if (
        this.props.user.acl.filter(
          (e) => e.id === transactionType.TransactionType && e.perms.read
        ).length > 0
      ) {
        showModule = true;
      }
    }
    if (this.props.registration.registration.PincodeIntegration) {
      if (
        this.props.registration.registration.hasOwnProperty(
          "PinocdeOrderTransactionTypeID"
        ) &&
        this.props.registration.registration.PinocdeOrderTransactionTypeID ===
        transactionType.key
      ) {
        showModule = false;
      }
    }
    return showModule;
  }

  componentDidMount() {
      let saved = this.props.getPageFilters("InventoryList");

  let page = 1;
  let pageSize = 25;
  let searchParam = "";
  let isFilterActive=false;
  let filter = { ...this.state.filter };



  if (saved) {
    console.log("saved",saved);
    filter = saved.PageFilters || filter;
    searchParam = saved.SearchText || "";
    page = saved.ActivePage || 1;
    isFilterActive=saved.IsFilterActive;

    // recordFrom → convert back to page
    if (saved.RecordFrom) {
      page = Math.floor(saved.RecordFrom / pageSize) + 1;
    }
  }
    let inventoryTransactionTypes = [];

   

    this.props.config.TransactionTypes.filter(
      (e) => e.Module === "inventory" && !e.IsDeleted
    ).map((e) => {
      if (this.showTransactionType(e)) {
        inventoryTransactionTypes.push(e);
      }
    });

     const storeId =filter.storeId ||  this.props.user.store.key;
    
    this.setState(
      {
        filter: {
            ...filter,
          storeId: storeId
        },
          isFilterActive:isFilterActive,
      searchParam:searchParam,
      page,
      inventoryTransactionTypes,
      stores: this.props.config.UserStores,
      },
      () => {
        this.loadData();
      }
    );
  }

  getSelectedStoreIds = () => {
    var storeId = this.state.filter.storeId;

    if (!storeId) {
      var keys = this.state.stores
        .filter(function (s) {
          return (s.key !== null && s.key !== undefined && s.key !== "");
        })
        .map(function (s) {
          return s.key;
        });
      return keys;
    }
    return storeId;
  };

  loadData = async () => {
    this.setState({ loading: true });

    try {
      const { page, pageSize, filter, searchParam } = this.state;
      const from = (page - 1) * pageSize;

      const res = await this.props.getInventoryList(
        from,
        pageSize,
        null,
        this.getSelectedStoreIds(),
        filter.fromDate,
        filter.toDate,
        filter.transactionTypeId,
        filter.transactionNo,
        filter.vendorFirstName,
        filter.vendorEmailId,
        filter.vendorPhoneNo,
        searchParam,
        null,
        filter.vendorCode
      );

      let list = [];
      let totalCount = 0;

      if (res && res.hasOwnProperty("inventory") && res.inventory.length > 0) {
        list = res.inventory;
      }

      if (res && res.hasOwnProperty("totalCount")) {
        totalCount = res.totalCount;
      }

      this.setState({
        list: list,
        totalCount: totalCount,
        loading: false,
        selectAll: false
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  onSearch = (text) => {
  this.setState({ searchParam: text, page: 1 }, () => {
    this.savePageFilters();
    this.loadData();
  });
};

onRefreshClick = () => {
  const defaultStoreId = this.props.user.store.key;
  this.setState(
    {
      filter: {
     storeId: defaultStoreId,
        transactionTypeId: "",
        fromDate: "",
        toDate: "",
        transactionNo: "",
        vendorFirstName: "",
        vendorPhoneNo: "",
        vendorEmailId: "",
        vendorCode: "",
        refNo: "",
      },
      page: 1,
      isFilterActive: false,
      searchParam: "",
    },
    () => {
      this.savePageFilters();
      this.loadData();
    }
  );
};
 

  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 }, this.loadData);
    }
  };

  onPreviousClick = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 }, this.loadData);
    }
  };

  onFirstClick = () => {
    this.setState({ page: 1 }, this.loadData);
  };

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages }, this.loadData);
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({ pageSize: Number(size), page: 1 }, this.loadData);
  };

  

    onApplyFilter = () => {
  this.setState(
    { page: 1, showFilter: false, isFilterActive: true },
    () => {
      this.savePageFilters();
      this.loadData();
    }
  );
};

  onClearFilter = () => {
    this.onRefreshClick();
    this.setState({ showFilter: false });
  };

  exportColumns = [
    { header: "Store header", field: "Store.StoreName" },
    { header: "Store Location", field: "StoreLocation" },
    { header: "From Store", field: "FromStore" },
    { header: "To Store", field: "ToStore" },
    { header: "Vendor Code", field: "Vendor.VendorCode" },
    {
      header: "Vendor header",
      field: "Vendor.VendorFirstName"
    },
    { header: "Vendor Phone No.", field: "Vendor.PhoneNo" },
    { header: "Transaction No", field: "TransactionNo" },
    { header: "Ref No", field: "RefNo" },
    {
      header: "Transaction type",
      field: "TransactionType.TransactionType",
    },
    { header: "Transaction Date", field: "TransactionDate", type: "date" },
    { header: "Qty", field: "BillQty", type: "number" },
    { header: "Total Tax", field: "BillTaxAmount", type: "number" },
    { header: "Discount", field: "BillDiscount", type: "number" },
    {
      header: "Additional Discount",
      field: "BillAdditionalDiscount",
      type: "number",
    },
    {
      header: "Additional Charges",
      field: "BillAdditionalCharges",
      type: "number",
    },
    { header: "Round Off", field: "BillRoundOff", type: "number" },
    { header: "Amount", field: "BillAmount", type: "number" },
    {
      header: "Paid Amount",
      field: "PaidAmount",
      type: "number",
    },
    {
      header: "Balance Amount",
      field: "BalanceAmount",
      type: "number",
    },
    { header: "Cancelled", field: "Cancelled", type: "boolean" },
    { header: "Status", field: "Status" },
    { header: "Notes", field: "Notes" },
  ];

getExportData = async () => {
  const MAX_RECORDS = 10000;
  const PAGE_SIZE = 2000;

  const { filter, searchParam } = this.state;

  let allInventory = [];
  let currentPage = 0;
  let hasMoreData = true;
  let totalCount = 0;

  try {
    while (hasMoreData) {
      const res = await this.props.getInventoryList(
        currentPage * PAGE_SIZE, // offset
        PAGE_SIZE,               // page size
        null,
        this.getSelectedStoreIds(),
        filter.fromDate,
        filter.toDate,
        filter.transactionTypeId,
        filter.transactionNo,
        filter.vendorFirstName,
        filter.vendorEmailId,
        filter.vendorPhoneNo,
        searchParam,
        null,
        filter.vendorCode
      );

      if (!res || !res.hasOwnProperty("inventory")) {
        break;
      }

      // First call → determine capped total
      if (currentPage === 0) {
        totalCount = Math.min(res.totalCount || 0, MAX_RECORDS);
      }

      if (Array.isArray(res.inventory)) {
        const remaining = MAX_RECORDS - allInventory.length;
        allInventory.push(...res.inventory.slice(0, remaining));
      }

      // Continue or stop
      if (allInventory.length < totalCount) {
        currentPage++;
      } else {
        hasMoreData = false;
      }
    }

    return allInventory;
  } catch (err) {
    console.error("Error fetching inventory export data:", err);
    return [];
  }
};

  handleExport = async (type) => {
    this.setState({ loading: true });

    try {
      const data = await this.getExportData();

      if (!data || data.length === 0) {
        alert("No data available to export");
        return;
      }

      const updatedData = data.map((item) => {
        const bill = Number(item.BillAmount || 0);
        const paid = Number(item.PaidAmount) || Number(item.Paid) || 0;

        return {
          ...item,
          PaidAmount: paid,
          BalanceAmount: bill - paid,
        };
      });

      await exportFile({
        data: updatedData,
        columns: this.exportColumns,
        fileType: type,
        title: "Inventory",
        landscape: true,
      });
    } catch (error) {
      console.error(error);
      alert("Export failed");
    } finally {
      this.setState({ loading: false });
    }
  };

  async onConvertTransaction(transactionType, copy = false) {
    if (
      transactionType &&
      transactionType.Module.toLowerCase() === "inventory"
    ) {
      let selectedRecordsTemp = [];
      let firstRecord = false;
      let firstRecordData = null;
      selectedRecordsTemp = this.state.list.filter((f) => f.Selected);

      if (selectedRecordsTemp.length === 0) {
        alert("Please select record(s).");
        return;
      }
      
      for (let i = 0; i < selectedRecordsTemp.length; i++) {
        let record = selectedRecordsTemp[i];
        
        if (!firstRecord) {
          firstRecordData = record;
          firstRecord = true;
          if (
            transactionType.TransactionType ===
            firstRecordData.TransactionType.TransactionType
          ) {
            alert(
              "Transaction can not be converted to same type. Please select different transaction types."
            );
            return;
          }
        } else {
          if (
            record.TransactionType.TransactionType !==
            firstRecordData.TransactionType.TransactionType
          ) {
            alert("Selected records should be of same transaction type");
            return;
          }
          if (!firstRecordData.Vendor && record.Vendor) {
            alert("Selected records should have same vendor");
            return;
          }
          if (firstRecordData.Vendor && !record.Vendor) {
            alert("Selected records should have same vendor");
            return;
          }
          if (firstRecordData.ToStoreID !== record.ToStoreID) {
            alert("Selected records should have same To Store");
            return;
          }
          if (firstRecordData.Vendor && record.Vendor) {
            if (firstRecordData.Vendor.key !== record.Vendor.key) {
              alert("Selected records should have same vendor");
              return;
            }
          }
        }
        if (record.Status.toLowerCase() === "in transit") {
          alert("In transit records can not be converted");
          return;
        }
        if (record.Status.toLowerCase() !== "completed") {
          alert("Only completed record(s) can be converted");
          return;
        }
      }

      let inventory = {
        TransactionType: transactionType,
        Vendor: firstRecordData.hasOwnProperty("Vendor")
          ? firstRecordData.Vendor
          : null,
        RegistrationID: this.props.user.user.RegistrationID,
        Store: this.props.user.store,
        LineItems: [],
        BillQty: 0,
        BillSubTotal: 0,
        BillDiscount: 0,
        BillTaxAmount: 0,
        BillAmount: 0,
        ParentTransactionNo: "",
        ParentTransactionKey: "",
        Notes: "",
        TaxSummaryList: null,
        HSNSummary: [],
        PlaceOfSupply: firstRecordData.hasOwnProperty("PlaceOfSupply")
          ? firstRecordData.PlaceOfSupply
          : "",
        StoreLocation: "",
        StoreLocationID: "",
        RefNo: "",
        BackEndUpdate: false,
        Status: "Completed",
        ToStoreID: firstRecordData.hasOwnProperty("ToStoreID")
          ? firstRecordData.ToStoreID
          : "",
        ToStore: firstRecordData.hasOwnProperty("ToStore")
          ? firstRecordData.ToStore
          : "",
        ChildTransactionNo: "",
        ChildTransactionKey: "",
        BillLineItemTotal: 0,
        BillRoundOff: 0,
        BillAdditionalCharges: 0,
        BillAdditionalDiscount: 0,
      };

      inventory.ParentTransactions = [];
      let refNo = "";
      
      for (let k = 0; k < selectedRecordsTemp.length; k++) {
        let recordToBeConverted = false;
        let record = await this.props.getInventoryDetails(
          selectedRecordsTemp[k].key
        );
        record.key = selectedRecordsTemp[k].key;
        
        inventory.ParentTransactionNo = inventory.ParentTransactionNo.trim() !== "" 
          ? inventory.ParentTransactionNo + "," + record.TransactionNo 
          : record.TransactionNo;
          
        inventory.ParentTransactionKey = inventory.ParentTransactionKey.trim() !== "" 
          ? inventory.ParentTransactionKey + "," + record.key 
          : record.key;
          
        record.LineItems.map((l, index) => {
          let lineItem = {};
          let parentTransactionRemainingQty = l.hasOwnProperty("RemainingQty")
            ? l.RemainingQty
            : l.Qty;
            
          if (parentTransactionRemainingQty > 0) {
            lineItem.LineItemQty = parentTransactionRemainingQty;
            lineItem.FreeQty = 0;
            lineItem.Qty = parentTransactionRemainingQty;
            lineItem.SupplyPrice = l.SupplyPrice;
            lineItem.SubTotal = 0;
            lineItem.ChargeTaxOnProduct = l.ChargeTaxOnProduct;
            lineItem.PriceBasedTax = l.PriceBasedTax;
            lineItem.HSNSACCode = l.HSNSACCode;
            lineItem.TaxInclusive = l.TaxInclusive;
            lineItem.TaxGroup = l.TaxGroup;
            lineItem.TaxID = l.TaxID;
            lineItem.DiscountPer = 0;
            lineItem.DiscountAmount = 0;
            lineItem.SubTotalWithDiscount = 0;
            lineItem.TaxableAmount = 0;
            lineItem.TotalTax = 0;
            lineItem.Amount = 0;
            lineItem.Product = l.Product;
            lineItem.Notes = record.TransactionNo;
            lineItem.UniqueNoList = [];
            lineItem.InStockQty = 0;
            lineItem.ParentTransactionNo = record.TransactionNo;
            lineItem.ParentTransactionKey = record.key;
            lineItem.ParentTransactionLineItemIndex = index;
            lineItem.ParentTransactionRemainingQty = parentTransactionRemainingQty;

            lineItem.BatchNo = "";
            lineItem.BatchMRP = 0;
            lineItem.BatchRetailPrice = 0;
            lineItem.BatchMfgDate = "";
            lineItem.BatchExpDate = "";
            lineItem.BatchMfgDateValue = null;
            lineItem.BatchExpDateValue = null;

            recordToBeConverted = true;
            inventory.LineItems.push(lineItem);
          }
        });
        
        if (recordToBeConverted) {
          refNo = refNo !== "" ? refNo + "," + record.TransactionNo : record.TransactionNo;
          inventory.ParentTransactions.push({
            ParentTransactionKey: record.key,
            ParentTransactionNo: record.TransactionNo,
          });
        }
      }
      
      if (
        inventory.TransactionType.UpdateStockChecked &&
        firstRecordData.TransactionType.UpdateStockChecked
      ) {
        inventory.TransactionType.UpdateStockChecked = false;
      }
      
      inventory.RefNo = refNo;
      
      this.props.history.push({
        pathname: "/home/inventory/inventory/",
        state: {
          type: actionTypes.INVENTORY_NEW,
          inventory: inventory,
          transactionType: transactionType,
        },
      });
    }
  }

  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new") {
      this.setState({ showNewModal: true });
    }
    if (btn.Action === "convert") {
      this.setState({ showConvertPopup: true });
    }
    if (btn.Action === "options") {
      this.setState({ showOption: true });
    }
      if (btn.Action === "Parked") {
    this.setState({ showParkedModal: true }, () => {
      this.getInventoryParkedTransactions();
    });
  }
  };




async getInventoryParkedTransactions() {
  this.setState({ loading: true });

  try {
    let inventoryDrafts = await this.props.getDraftTransactions("Inventory");

    this.setState({
      inventoryDrafts: inventoryDrafts || [],
      loading: false
    });
  } catch (error) {
    console.error(error);
    this.setState({ loading: false });
  }
}
   onPageChange = (page, pageSize) => {
    this.setState(
      { page, pageSize },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };
  savePageFilters = () => {
  const { filter, searchParam, page, pageSize,isFilterActive } = this.state;
  console.log("418 saving page filters");
  this.props.setPageFilters(
    "InventoryList",
    filter,
    searchParam,
    (page - 1) * pageSize, // recordFrom
    page,
    isFilterActive
  );
};

  render() {
    const headerButtons = [
      {
        ButtonType: "Button",
        Type: "primary",
        Text: "New",
        Icon: "add",
        Action: "new"
      },
         {
            ButtonType: "Button",
            Type: "secondary",
            Text: "Parked",
            Icon: "",
            Action: "Parked"
          },
      {
        ButtonType: "ImageButton",
        Type: "option",
        Text: "Options",
        Icon: "option",
        Action: "options"
      }
    ];

    if (this.state.showSelectionOption) {
      headerButtons.unshift(
        {
          ButtonType: "Button",
          Type: "secondary",
          Text: "Convert",
          Icon: "",
          Action: "convert"
        }
      );
    }

    const listPageSettings = {
      ...this.state.listPageSettings,
      HeaderButtons: headerButtons,
      Search: {
        ...this.state.listPageSettings.Search,
        isFilterActive: this.state.isFilterActive
      }
    };
    
    return (
      <>
        <ListingPage
          {...this.props}
          listPageSettings={listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          checkboxSelected={this.checkboxSelected}
          selectAll={this.state.selectAll}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onPageChange={this.onPageChange}
           onRowClick={(row) => {
        this.props.history.push("/home/inventory/viewinventory/" + row.key);
      }}
      searchText={this.state.searchParam} 
        />

        {this.state.showFilter && (
          <Window
            header="Filter"
            size="small"
            slide={true}
            onClose={() => this.setState({ showFilter: false })}
            onButtonClick={(action) => {
              if (action === "Apply") this.onApplyFilter();
              if (action === "Clear") this.onClearFilter();
            }}
            buttons={[
              { Type: "secondary", Text: "Clear", Align: "left" },
              { Type: "primary", Text: "Apply", Align: "right" }
            ]}
          >
            <Input
              type="select"
              label="Store"
              value={this.state.filter.storeId}
              onChange={(v) => {
                this.setState({
                  filter: { ...this.state.filter, storeId: v }
                });
                this.loadCashRegister(v);
              }}
            >
              {this.state.stores.map((s) => (
                <option key={s.key} value={s.key}>
                  {s.StoreCode} {s.StoreName}
                </option>
              ))}
            </Input>

            <Input
              type="select"
              label="Transaction Type"
              value={this.state.filter.transactionTypeId}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, transactionTypeId: v }
                })
              }
            >
              <option value="">All</option>
              {this.props.config.TransactionTypes.filter(
                (e) => e.Module === "inventory" && !e.IsDeleted
              ).map((e) => (
                <option key={e.key} value={e.key}>{e.TransactionType}</option>
              ))}
            </Input>

            <Input
              type="date"
              label="From Date"
              value={this.state.filter.fromDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, fromDate: v }
                })
              }
            />

            <Input
              type="date"
              label="To Date"
              value={this.state.filter.toDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, toDate: v }
                })
              }
            />

            <Input
              type="text"
              label="Transaction No"
              value={this.state.filter.transactionNo}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, transactionNo: v }
                })
              }
            />

            <Input
              type="text"
              label="Vendor Code"
              value={this.state.filter.vendorCode}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, vendorCode: v }
                })
              }
            />

            <Input
              type="text"
              label="Vendor Name"
              value={this.state.filter.vendorFirstName}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, vendorFirstName: v }
                })
              }
            />

            <Input
              type="text"
              label="Vendor Phone No"
              value={this.state.filter.vendorPhoneNo}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, vendorPhoneNo: v }
                })
              }
            />

            <Input
              type="text"
              label="Vendor Email Id"
              value={this.state.filter.vendorEmailId}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, vendorEmailId: v }
                })
              }
            />
          </Window>
        )}

        {this.state.showNewModal && (
          <ChoicePopup
            header={"New Transaction"}
            height={"200px"}
            stripNew
            onClose={() => this.setState({ showNewModal: false })}
          >
            {this.renderNewInventoryPopup()}
          </ChoicePopup>
        )}

       {this.state.showOption && (
  <Window
    header="Options" choiceList
    size="small"
    slide={true}
    onClose={() => this.setState({ showOption: false })}
  >
        {this.props.user.user.hasOwnProperty("RoleKey") && 
     this.props.user.user.RoleKey !== "" && 
     this.props.getVisibility("Inventory", "export") === "none" ? (
      null // or a placeholder component if needed
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ExportButton
          onExport={this.handleExport}
          loading={this.state.loading}
        />
      </div>
    )}
  </Window>
)}
    {this.state.showParkedModal && (
  <Window
    header="Parked Transaction(s)"
    size="medium"
    slide={true}
    onClose={() => this.setState({ showParkedModal: false })}
  >
    {this.state.loading ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        {/* Replace with your Spinner component */}
         <Spinner/>
      </div>
    ) : this.state.inventoryDrafts.length === 0 ? (
      <div style={{ textAlign: "center" }}>
        No parked transactions found
      </div>
    ) : (
      this.state.inventoryDrafts.map((draftTransaction, index) => (
        <div
          className="info"
          key={index}
          onClick={() => {
            this.props.deleteDraftTransaction(draftTransaction.key);
            this.props.history.push({
              pathname: "/home/inventory/inventory/",
              state: {
                type: actionTypes.INVENTORY_PARKED,
                key: "",
                transactionType:
                  draftTransaction.Transaction.TransactionType,
                inventory: draftTransaction.Transaction,
              },
            });
          }}
        >
          {draftTransaction.ActionOn && (
            <div className="info-header">
              {new Date(draftTransaction.ActionOn._seconds * 1000)
                .toString()
                .substring(0, 24)}
            </div>
          )}
          <div className="info-text">
            Qty: {draftTransaction.Transaction.BillQty}
          </div>
          <div className="info-text">
            Amount: {draftTransaction.Transaction.BillAmount}
          </div>
        </div>
      ))
    )}
  </Window>
)}


        {this.state.showConvertPopup && (
          <ChoicePopup
            header="Convert"
            sheetTitle="Convert to"
            stripNew
            onClose={() => this.setState({ showConvertPopup: false })}
          >
            {this.renderConvertInventory()}
          </ChoicePopup>
        )}
      </>
    );
  }
}

export default InventoryList;